/**
 * A minimal scroll-snap carousel: the track scrolls natively (swipe works
 * for free), and the prev/next buttons and dots just nudge scrollLeft by
 * one slide width. No custom element, no state beyond "which slide is
 * nearest the scroll position right now" - there's nothing else to track.
 *
 * The prev/next buttons wrap rather than stop at the ends: next from the
 * last slide goes to the first, prev from the first goes to the last, so a
 * shopper working through the lineup with the arrows never hits a dead
 * stop. Dots still target an exact slide, so wrapping only applies to the
 * relative prev/next step.
 */

function initCarousel(root) {
  const track = root.querySelector('[data-cbs-track]');
  const prevButton = root.querySelector('[data-cbs-prev]');
  const nextButton = root.querySelector('[data-cbs-next]');
  const dots = Array.from(root.querySelectorAll('[data-cbs-dot]'));

  if (!track) return;

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const slides = Array.from(track.children);
  if (slides.length === 0) return;

  function currentIndex() {
    const slideWidth = track.clientWidth;
    if (slideWidth === 0) return 0;
    return Math.round(track.scrollLeft / slideWidth);
  }

  function goToIndex(index) {
    const clamped = Math.max(0, Math.min(index, slides.length - 1));
    // A behavior passed here overrides the CSS scroll-behavior rule, which base.css
    // already gates behind prefers-reduced-motion - so honour the preference again.
    const reduceMotion = reducedMotionQuery.matches;
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  }

  function wrappedIndex(index) {
    return ((index % slides.length) + slides.length) % slides.length;
  }

  function updateDots() {
    const index = currentIndex();
    dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', String(dotIndex === index));
    });
  }

  prevButton?.addEventListener('click', () => goToIndex(wrappedIndex(currentIndex() - 1)));
  nextButton?.addEventListener('click', () => goToIndex(wrappedIndex(currentIndex() + 1)));

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToIndex(index));
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateDots, 100);
  });

  updateDots();
}

document.querySelectorAll('[data-cutting-boards-showcase]').forEach(initCarousel);
